import React, { useEffect, useState } from "react";
import {
  Container,
  Description,
  ContainerDescription,
  Title,
  Value,
  Line,
  ContentCard,
  ContainerNoItems,
} from "./style";
import Navbar from "../../components/navbar/navbar";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/footer/footer";
import { useTranslation } from "react-i18next";
import { loadStripe } from "@stripe/stripe-js";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import { useServiceShoppingCart } from "../../hooks/serviceShoppingCart";

import CardProduct from "../../components/card-product/card-product";
import PaymentMethods from "./components/Payment-methods";
import { storageServerPath } from "../../utils/server/api";
import CardCheckout from "@/components/CardCheckout";
import { Elements } from "@stripe/react-stripe-js";
import { property } from "lodash";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY!);

export default function Order() {
  type Favorite = {
    id: number;
    product: {
      id: number;
      image: string;
      name: string;
      qtd_carbon: number;
    };
    price: number;
    qty: number;
  };

  const initialFavorites: Favorite[] = [
    {
      id: 0,
      product: {
        id: 0,
        image: "",
        name: "",
        qtd_carbon: 0,
      },
      price: 0,
      qty: 0,
    },
  ];

  const [deletecards, setDeleteCards] = useState(initialFavorites);
  const [dollarQuotation, setDollarQuotation] = useState<number>(0);
  const totalValue = deletecards.reduce(
    (total, item) => total + item.price * item.qty,
    0
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLoading = false;
  const { getCart, removeItem, alterQuantity, getDollarQuotation } =
    useServiceShoppingCart();
  const [selected, setSelected] = useState<string | null>(null);
  const { paymentCreate } = useServiceShoppingCart();

  const handleSelect = (method: string) => {
    setSelected((prev) => (prev === method ? null : method));
  };

  const createPaymentApi = async () => {
    if (selected === "boleto") {
      const data = {
        amount: totalValue,
        payment_method: selected,
      };

      await paymentCreate(data)
        .then((response) => {
          navigate(`/${selected === "boleto" ? "ticket" : ""}`, {
            state: { response: response.data },
          });
        })
        .catch((error) => {
          //mexer aqui
        });
    }

    /*if (selectedPaymentMethod === "card") {
        navigate('/CreditCardPayment', {
            state: { response: {amount: amount} },
        });
    }*/
  };

  useEffect(() => {
    async function fetchCart() {
      const data = await getCart();

      const quotation = await getDollarQuotation();
      setDollarQuotation(Number(quotation.USDBRL.bid));

      if (data.status === "waiting") {
        navigate(
          `/${
            data.payment_method === "boleto" ? "ticket" : "CreditCardPayment"
          }`,
          {
            state: { response: data?.tickets[0] },
          }
        );
      }

      if (
        data.status !== "waiting" &&
        data.status !== "opened" &&
        data.status !== "error"
      ) {
        setDeleteCards(initialFavorites);
        return;
      }

      const price = 10 * Number(quotation.USDBRL.bid);
      let newData: Favorite[] = data.items.map((item) => ({
        id: item.id,
        product: {
          id: item.property?.id,
          image: storageServerPath + item.property?.file_images?.split(";")[0],
          name: `${item.property?.name}`,
          qtd_carbon: item.property?.carbon_credits_available,
        },
        price: price,
        qty: Number(item.quantity) || 0,
      }));

      setDeleteCards(newData);
    }

    fetchCart();
  }, []);

  const deleteItem = async (id: number) => {
    await removeItem(id).then(() => {
      setDeleteCards((currentDeleteCards) =>
        currentDeleteCards.filter((card) => card.id !== id)
      );
    });
  };

  const updateQuantity = (id: number, newQty: number, propertyId: number) => {
    const pricePerCredit = 10 * dollarQuotation;
    setDeleteCards((currentCards) =>
      currentCards.map((card) =>
        card.id === id ? { ...card, qty: newQty, price: pricePerCredit } : card
      )
    );

    alterQuantity({
      propertyId: propertyId,
      quantity: newQty,
    }).then(() => {
      console.log("alter quantity is sucessfully.");
    });
  };

  return (
    <div className="flex-col items-center justify-center">
      <h1 className="!text-4xl !text-[#50700f] !font-medium pl-10 pt-10">
        Checkout
      </h1>
      {deletecards.length > 0 && deletecards[0].id > 0 ? (
        <div className="mt-8 p-12 gap-10 flex-col !items-center !border-2 border-[#D9D9D9] rounded-lg w-[90%] mx-auto">
          <div className="w-full border-2 rounded-lg px-5">
            <div className="block flex-col gap-[72%]">
              {/*              <div>
                <h1 className="!text-3xl text-[#50700f] w-[95%]">
                  {t("amount")}
                </h1>
                <p className="text-lg">
                  R${" "}
                  {totalValue.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </p>
              </div>*/}
            </div>
            {!isLoading && (
              <>
                {deletecards.map((item, index) => (
                  <ContentCard key={index}>
                    <CardProduct
                      id={item.product.id}
                      image={item.product.image}
                      title={item.product.name}
                      price={totalValue}
                      qtd_carbon={item.qty}
                      minQty={1}
                      maxQty={item.product.qtd_carbon}
                      deleteItem={() => deleteItem(item.id)}
                      updateQuantity={(newQty) =>
                        updateQuantity(item.id, newQty, item.product.id)
                      }
                    />
                  </ContentCard>
                ))}
              </>
            )}
          </div>
          <Line />
          <div className="mt-10 flex-col mx-auto">
            <h2 className="!text-2xl !font-medium !mb-6 !text-[#50700f]">
              Escolha a forma de pagamento
            </h2>

            <div className="flex flex-col gap-4">
              {/* Cartão de Crédito (Accordion) */}
              <div
                onClick={() => handleSelect("cartao")}
                className={`cursor-pointer !border-2 !border-black rounded-xl p-8 ${
                  selected === "cartao" ? "!bg-[#E1E7D6]" : "border-gray-300"
                }`}
              >
                <p className="font-medium">Cartão de Crédito</p>

                {selected === "cartao" && (
                  <div
                    className="mt-4 space-y-3"
                    onClick={(e) => e.stopPropagation()} // <- impede o clique de fechar o accordion
                  >
                    <Elements stripe={stripePromise}>
                      <CardCheckout
                        cost={totalValue}
                        property_id={deletecards[0].product.id}
                        quantity={deletecards[0].qty}
                      />
                    </Elements>
                  </div>
                )}
              </div>

              {/* Boleto */}
              <div
                onClick={() => handleSelect("boleto")}
                className={`cursor-pointer !border-2 !border-black rounded-xl p-8 ${
                  selected === "boleto" ? "!bg-[#E1E7D6]" : "border-gray-300"
                }`}
              >
                <p className="font-medium">Boleto</p>
              </div>
            </div>

            {/* Botão de pagamento aparece se tiver uma opção selecionada */}
            {selected && (
              <button
                className="!mt-6 !bg-[#5c8014] !text-white !py-3 !px-20 rounded-bl-2xl rounded-tr-2xl transition-all duration-300
                    hover:rounded-tl-2xl hover:rounded-br-2xl hover:rounded-tr-none hover:rounded-bl-none 
                "
                onClick={() => createPaymentApi()}
              >
                Realizar Pagamento
              </button>
            )}
          </div>
          {
            // <PaymentMethods amount={totalValue}/>
          }
        </div>
      ) : (
        <div className="flex w-[90%] h-64 items-center justify-center !border-2 border-[#EDE2E2] m-16 flex-col text-center mx-auto">
          <Title>{t("no-order")}</Title>
          <p>
            {t("order-description")}
            <button
              onClick={() => {
                navigate("/news");
              }}
              style={{
                color: "#0788D1",
                fontFamily: "poppins",
              }}
            >
              {t("Click-here")}
            </button>
          </p>
        </div>
      )}
      <Footer />
    </div>
  );
}
